import { render, staticRenderFns } from "./bulkUploadComponent.vue?vue&type=template&id=45335152&"
import script from "./bulkUploadComponent.vue?vue&type=script&lang=js&"
export * from "./bulkUploadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports